import { render, staticRenderFns } from "./uploadFile .vue?vue&type=template&id=10b0d312&"
import script from "./uploadFile .vue?vue&type=script&lang=js&"
export * from "./uploadFile .vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports